module.exports = __webpack_public_path__ + "img/reload.a1db7e31.svg";